export const config = {
  fontFamily: 'Pathway Extreme',
  colors: {
    primary: 'rgb(254, 206, 0)',
    background: 'rgb(241, 243, 245)',
    disabled: {
      DEFAULT: 'rgb(247, 247, 247)',
      50: 'rgba(247, 247, 247, 0.5)',
    },
    active: 'rgba(0, 26, 153, 0.4)',
    text: {
      primary: 'rgb(33, 33, 33)',
      secondary: 'rgb(45, 54, 72)',
    },
  },
};
